import React from 'react';
import { View, Text, TextInput } from 'react-native';
import { globalStyles } from '../../styles/globalStyles';

export function FormField({ label, value, placeholder, type, onChange }) {
  return (
    <View style={globalStyles.fieldWrapper}>
      <Text style={globalStyles.fieldLabel}>{label}</Text>
      <TextInput
        style={globalStyles.fieldInput}
        value={value}
        placeholder={placeholder}
        placeholderTextColor="rgba(255, 255, 255, 0.25)"
        onChangeText={onChange}
        keyboardType={type === 'number' ? 'numeric' : 'default'}
      />
    </View>
  );
} 